import { InferType, object, string } from 'yup';

export const inviteUserFormValidationSchema = object().shape({
  firstName: string().required('First name is required'),
  lastName: string().required('Last name is required'),
  email: string().required('Email is required').email('Invalid email format'),
});

export type InviteUserFormFields = InferType<
  typeof inviteUserFormValidationSchema
>;
